export default __webpack_public_path__ + "static/media/campaign-ads.af9f37ca.svg";